const creditsFormatter = new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 })

const currencyFormatters = new Map<string, Intl.NumberFormat>()

const getCurrencyFormatter = (currency: string): Intl.NumberFormat => {
  const normalizedCurrency = currency.toUpperCase()
  const cachedFormatter = currencyFormatters.get(normalizedCurrency)

  if (cachedFormatter) {
    return cachedFormatter
  }

  const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: normalizedCurrency })
  currencyFormatters.set(normalizedCurrency, formatter)

  return formatter
}

export const formatCredits = (n: number): string => creditsFormatter.format(n)

export const formatCurrencyFromCents = (cents: number, currency: string): string => getCurrencyFormatter(currency).format(cents / 100)
